import Vue from "vue";
import axios from "axios";
import App from "./App.vue";
import router from "./router";

import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";

import "@/assets/global.scss"; // 全局样式

// 国际化使用
import VueI18n from "vue-i18n";
import zhCN from "./lang/zh-CN";
import enUS from "./lang/en-US";
Vue.use(VueI18n);
const messages = {
  "zh-CN": zhCN,
  "en-US": enUS,
};

// 其他页面也用到了 storage 里的语言设置，所以这里预设一下，避免修改其他页面的判断
if (!localStorage.getItem("lang")) {
  localStorage.setItem("lang", "en-US"); // 设置默认语言为中文
}
const i18n = new VueI18n({
  locale: localStorage.getItem("lang") || "en-US", // 默认语言
  messages,
});

Vue.use(ElementUI);

//vue-fullpage
// import 'default-passive-events'
// import 'swiper/css/swiper.css'
// import VueFullpage from 'vue-fullpage.js'
// Vue.use(VueFullpage)

//中央事件总线
Vue.config.productionTip = false;
Vue.prototype.$axios = axios;
Vue.prototype.$bus = new Vue();

//获取字体得大小
window.addEventListener("load", () => {
  let fs = (document.documentElement.clientWidth * 15) / 1440;
  document.querySelector("html").style.fontSize = fs + "px";
  window.addEventListener("resize", function () {
    let fs = (document.documentElement.clientWidth * 15) / 1440;
    document.querySelector("html").style.fontSize = fs + "px";
  });
});

//引入懒加载
import VueLazyload from "vue-lazyload";
Vue.use(VueLazyload, {
  observer: true,
  observerOptions: {
    rootMargin: "0px",
    threshold: 0.1,
  },
  loading: "data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs=",
});

//禁止网页缩放
document.addEventListener(
  "mousewheel",
  function (event) {
    event = event || window.event;
    if (event.wheelDelta && event.ctrlKey) {
      event.preventDefault();
    }
  },
  {
    capture: false,
    passive: false,
  }
);

//禁止网页缩放
document.addEventListener(
  "DOMMouseScroll",
  function (event) {
    event = event || window.event;
    // event.detail 属性和 mousewheel 事件的 wheelDelta 属性是一个意思
    if (event.detail && event.ctrlKey) {
      event.preventDefault();
    }
  },
  {
    capture: false,
    passive: false,
  }
);

//引入检测设备得组件
import device from "current-device";
Vue.use(device);

//引入动画
import "vue2-animate/dist/vue2-animate.min.css";
import "animate.css";
router.afterEach((to) => {
  document.title = to.meta.title || "沛岱汽车丨精准仿真引领者";
});

new Vue({
  i18n,
  router,
  axios,
  render: (h) => h(App),
}).$mount("#app");
